// src/pages/ProfileSetup.js
import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function ProfileSetup() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSave = async (e) => {
    e.preventDefault();
    setError("");
    const user = auth.currentUser;

    if (!user) {
      const msg = "You must be logged in to set up your profile.";
      setError(msg);
      toast.error(msg);
      navigate("/login");
      return;
    }

    try {
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, {
        firstName,
        lastName,
        phone,
        country,
        email: user.email,
      });
      navigate("/profile");
    } catch (err) {
      let msg;
      if (err.code === "permission-denied" || (err.message && err.message.includes("permission"))) {
        msg = "We don't have permission to save your profile. Please check Firestore rules or contact support.";
      } else {
        msg = err.message || "Could not save profile. Please try again.";
      }
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <form onSubmit={handleSave} className="bg-white p-6 rounded-lg shadow-md w-96 space-y-4">
        <h2 className="text-2xl font-bold text-center">Complete Your Profile</h2>

        {error && <p className="text-red-500 text-sm text-center">{error}</p>}

        <input type="text" placeholder="First Name" className="w-full p-2 border rounded" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
        <input type="text" placeholder="Last Name" className="w-full p-2 border rounded" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        <input type="text" placeholder="Phone" className="w-full p-2 border rounded" value={phone} onChange={(e) => setPhone(e.target.value)} required />
        <input type="text" placeholder="Country" className="w-full p-2 border rounded" value={country} onChange={(e) => setCountry(e.target.value)} required />

        <button type="submit" className="w-full bg-brand text-black font-semibold py-2 rounded">Save Profile</button>
      </form>
    </div>
  );
}
